import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WeekendRetreat from './WeekendRetreat';
import MarchRetreat from './MarchRetreat';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WeekendRetreat />} />
        <Route path="/march-retreat" element={<MarchRetreat />} />
        {/* Legacy routes redirect */}
        <Route path="/october-retreat" element={<MarchRetreat />} />
      </Routes>
    </Router>
  );
}

export default App;
